import classNames from "classnames";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { FC } from "react";
import { Container } from "~/components/Container";
import { WorkingProcessStages } from "~/constants/data";
import Trans from "~/types/translationKeys";
import styles from "./OurWorkingProcess.module.scss";

const OurWorkingProcess: FC = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.our_working_process} id="our_working_process">
      <Container className={styles.container}>
        <div className={styles.left}>
          <h2 className={styles.title}>{t(Trans.our_working_process)}</h2>
          <h2 className={styles.content}>
            {t(
              Trans.at_cx_genie_our_workflow_is_designed_to_seamlessly_integrate_ai_solutions_with_your_business_goals_ensuring_optimal_performance_and_impact
            )}
          </h2>
          <Image
            src="/images/our_working_process.png"
            alt="Our Working Process"
            width={588}
            height={470}
          />
        </div>
        <div className={styles.right}>
          {WorkingProcessStages.map((stage, index) => (
            <div
              className={classNames(
                styles.timeline,
                styles[`timeline_${index + 1}`]
              )}
              key={index}
            >
              <div className={styles.stage}>
                {t(Trans.stage)} {index + 1}
              </div>
              <h3 className={styles.name}>{t(stage.name)}</h3>
              <div className={styles.contents}>
                {stage.contents.map((content, i) => (
                  <div className={styles.content_item} key={i}>
                    <div className={styles.round} />
                    <h4 className={styles.content}>{t(content)}</h4>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default OurWorkingProcess;
